import Vue from 'vue';
import Vuex from 'vuex';

import signin from './modules/signin';
import companyBranding from './modules/companyBranding';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    signin,
    companyBranding
  },
  state: {},
  mutations: {},
  actions: {}
});
